var CreateApplicationDetailsTpamsComponent_1;
import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-tpams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-tpams.component.scss?ngResource";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CreateApplicationDetailsTpamsConstants } from "./create-application-details-tpams.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { AppControllerService } from "../../../../app-controller.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
import { AlertType } from "../../../../shared/models/alert";
import { TownplanningService } from "../../../../shared/services/modules/townplanning.service";
import { mapTpApplicationTypeLimitToUiState, normalizeTpApplicationTypeLimit } from "../../../../shared/utils/tp-application-type-limit.utils";
let CreateApplicationDetailsTpamsComponent = class CreateApplicationDetailsTpamsComponent extends CreateApplicationViewBaseComponent {
    static { CreateApplicationDetailsTpamsComponent_1 = this; }
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appControllerService;
    changeDetectorRef;
    townPlanningService;
    searchApplicationsService;
    // form controls
    detailsFormControlName = CreateApplicationDetailsTpamsConstants.DETAILS_FORM_CONTROL_NAME;
    descriptionFormControlName = CreateApplicationDetailsTpamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    referenceNumberControlName = CreateApplicationDetailsTpamsConstants.REFERENCE_NUMBER_CONTROL_NAME;
    amendmentSchemeNumberFormControlName = CreateApplicationDetailsTpamsConstants.AMENDMENT_SCHEME_NUMBER_FORM_CONTROL_NAME;
    applicationTypesFormControlName = CreateApplicationDetailsTpamsConstants.APPLICATION_TYPES_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationDetailsTpamsConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    zonesFormControlName = CreateApplicationDetailsTpamsConstants.ZONES_FORM_CONTROL_NAME;
    zoneFormControlName = CreateApplicationDetailsTpamsConstants.ZONE_FORM_CONTROL_NAME;
    rezoneConfirmationControlName = CreateApplicationDetailsTpamsConstants.REZONING_APPLICATION_CONFIRMATION_CONTROL_NAME;
    previousReferenceNumberFormControlName = CreateApplicationDetailsTpamsConstants.PREVIOUS_APPLICATION_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    isResubmissionFormControlName = CreateApplicationDetailsTpamsConstants.IS_RESUBMISSION_FORM_CONTROL_NAME;
    // labels
    addApplicationTypeLabel = CreateApplicationDetailsTpamsConstants.ADD_APPLICATION_TYPE_LABEL;
    addZoneLabel = CreateApplicationDetailsTpamsConstants.ADD_ZONE_LABEL;
    removeLabel = SharedConstants.REMOVE_LABEL;
    applicationTypeLabel = CreateApplicationDetailsTpamsConstants.APPLICATION_TYPE_LABEL;
    zoneLabel = CreateApplicationDetailsTpamsConstants.ZONE_LABEL;
    descriptionLabel = CreateApplicationDetailsTpamsConstants.DESCRIPTION_LABEL;
    amendmentSchemeNumberLabel = CreateApplicationDetailsTpamsConstants.AMENDMENT_SCHEME_NUMBER_LABEL;
    referenceNumberLabel = CreateApplicationDetailsTpamsConstants.REFERENCE_NUMBER_LABEL;
    previousReferenceNumberLabel = CreateApplicationDetailsTpamsConstants.PREVIOUS_REFERENCE_NUMBER_LABEL;
    isResubmissionLabel = CreateApplicationDetailsTpamsConstants.IS_RESUBMISSION_LABEL;
    validationMessages = CreateApplicationDetailsTpamsConstants.VALIDATION_MESSAGES;
    applicationTypeLookupName = SharedConstants.APPLICATION_TYPE_LOOKUP_NAME;
    zoningLookupName = SharedConstants.ZONING_LOOKUP_NAME;
    detailsForm;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    applicationTypes = [];
    zones = [];
    showRefNumber = false;
    fullApplicationCheckRequired = false;
    rezoneConfirmationLabel = CreateApplicationDetailsTpamsConstants.REZONING_APPLICATION_CONFIRMATION_LABEL;
    rezoneKeywordRezone = CreateApplicationDetailsTpamsConstants.REZONING_KEYWORD_REZONE;
    rezoneKeywordRezoning = CreateApplicationDetailsTpamsConstants.REZONING_KEYWORD_REZONING;
    isRezoning = false;
    rezoningChecked = false;
    applicationTypesControl;
    appZones = [];
    applicationTypeLimit = CreateApplicationDetailsTpamsConstants.UNLIMITED_APPLICATION_TYPE_LIMIT;
    applicationTypeLimitReachedWarningMessage = CreateApplicationDetailsTpamsConstants.APPLICATION_TYPE_LIMIT_REACHED_WARNING_MESSAGE;
    applicationTypeLimitUiState = mapTpApplicationTypeLimitToUiState(this.applicationTypeLimit, 0);
    selectedApplicationDetailsTpamsSubscription;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appControllerService, changeDetectorRef, townPlanningService, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appControllerService = appControllerService;
        this.changeDetectorRef = changeDetectorRef;
        this.townPlanningService = townPlanningService;
        this.searchApplicationsService = searchApplicationsService;
    }
    static removeControlsByIndex(controls, index) {
        if (controls.controls.length > 1) {
            controls.removeAt(index);
        }
    }
    static setControlValue(formGroup, controlName, value, disableControl = false) {
        const formControl = formGroup.get(controlName);
        formControl.setValue(value);
        if (disableControl) {
            formControl.disable();
        }
    }
    ngOnInit() {
        this.initForm();
        this.ensureApplicationTypeDropdownIsVisible();
        this.loadApplicationTypeLimit();
        this.updateApplicationTypeLimitUiState();
        this.syncRezoningStateWithSelection();
        this.getApplicationTypeAndZoningLookups();
    }
    loadMetadata() {
        // step does not use metadata
    }
    getApplicationTypes() {
        return this.detailsForm.get(this.applicationTypesFormControlName);
    }
    onBtnRemoveApplicationTypeClicked(i) {
        const controls = this.getApplicationTypes();
        CreateApplicationDetailsTpamsComponent_1.removeControlsByIndex(controls, i);
        this.updateApplicationTypeLimitUiState();
        this.syncRezoningStateWithSelection();
    }
    getZones() {
        return this.detailsForm.get(this.zonesFormControlName);
    }
    onBtnRemoveZoneClicked(i) {
        const controls = this.getZones();
        CreateApplicationDetailsTpamsComponent_1.removeControlsByIndex(controls, i);
    }
    onBtnAddApplicationTypeClicked() {
        if (this.isApplicationTypeAddBlockedByLimit()) {
            return;
        }
        if (!this.canAddSelectionControl(this.getApplicationTypes(), this.applicationTypeFormControlName, this.applicationTypes, CreateApplicationDetailsTpamsConstants.ALL_APPLICATION_TYPES_ADDED_WARNING_MESSAGE)) {
            return;
        }
        this.addApplicationTypeControl();
        this.updateApplicationTypeLimitUiState();
    }
    shouldShowAddApplicationTypeButton() {
        return !this.applicationTypeLimitUiState.hideButtons && !this.applicationTypeLimitUiState.disableAdd;
    }
    onBtnAddZoneClicked() {
        if (!this.canAddSelectionControl(this.getZones(), this.zoneFormControlName, this.zones, CreateApplicationDetailsTpamsConstants.ALL_ZONES_ADDED_WARNING_MESSAGE)) {
            return;
        }
        this.addZoneControl();
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get(this.detailsFormControlName);
    }
    getApplicationTypeAndZoningLookups() {
        const filterString = `moduleId eq ${this.appControllerService.selectedModuleID} and (name eq '${this.applicationTypeLookupName}' or name eq '${this.zoningLookupName}')`;
        const params = {
            $filter: filterString,
        };
        this.applicationCreateService.getLookupsObservable(params).subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage(CreateApplicationDetailsTpamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        this.applicationTypes = [];
        this.zones = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === this.applicationTypeLookupName) {
                    this.applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name === this.zoningLookupName) {
                    this.zones.push(JSON.parse(item.content));
                }
            });
            this.sortZoneDropDownAlphabetically();
            this.sortApplicationTypesAlphabetically();
            this.changeDetectorRef.markForCheck();
            this.subscribeToSelectedApplication();
        }
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationDetailsTpamsSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.setApplicationDetails(application);
            }
        });
    }
    setApplicationDetails(application) {
        // checks the application has application details set
        if (application.referenceNumber) {
            this.showRefNumber = true;
            this.detailsForm.get(this.referenceNumberControlName).enable();
            CreateApplicationDetailsTpamsComponent_1.setControlValue(this.detailsForm, this.referenceNumberControlName, application.referenceNumber, true);
        }
        else {
            this.showRefNumber = false;
        }
        if (application.description) {
            CreateApplicationDetailsTpamsComponent_1.setControlValue(this.detailsForm, this.descriptionFormControlName, application.description);
        }
        else {
            this.detailsForm.get(this.descriptionFormControlName).enable();
        }
        if (application.amendmentSchemeNumber) {
            CreateApplicationDetailsTpamsComponent_1.setControlValue(this.detailsForm, this.amendmentSchemeNumberFormControlName, application.amendmentSchemeNumber);
        }
        else {
            this.detailsForm.get(this.amendmentSchemeNumberFormControlName).enable();
        }
        if (application.isResubmission) {
            this.detailsForm.get(this.isResubmissionFormControlName).setValue(application.isResubmission);
        }
        if (application.previousReferenceNumber) {
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValue(application.previousReferenceNumber);
        }
        if (application.applicationTypes && application.applicationTypes.length > 0) {
            const appTypes = application.applicationTypes;
            this.setTypes(appTypes);
        }
        else {
            this.resetApplicationTypesToDefaultControl();
        }
        if (application.applicationZonings && application.applicationZonings.length > 0) {
            const appZones = application.applicationZonings;
            this.setZones(appZones);
        }
        else {
            this.getZones().clear();
        }
        this.syncRezoningStateWithSelection();
        this.updateApplicationTypeLimitUiState();
    }
    setTypes(appTypes) {
        const typesControl = this.getApplicationTypes();
        typesControl.clear();
        const persistedApplicationTypes = this.getPersistedApplicationTypes(appTypes);
        persistedApplicationTypes.forEach(applicationType => {
            const appType = this.findApplicationTypeLookupOption(applicationType.applicationType);
            const typeGroup = new FormGroup({
                id: new FormControl(applicationType.id),
                applicationId: new FormControl(applicationType.applicationId),
                type: new FormControl(appType, Validators.min(1)),
                jobId: new FormControl(this.jobId)
            });
            typesControl.push(typeGroup);
        });
        this.updateApplicationTypeLimitUiState();
    }
    setZones(appZones) {
        const zonesControl = this.getZones();
        zonesControl.clear();
        appZones.forEach(applicationZoning => {
            let zone = null;
            this.zones.forEach(item => {
                if (item.value === applicationZoning.zoning) {
                    zone = item;
                }
            });
            const zoneGroup = new FormGroup({
                id: new FormControl(applicationZoning.id),
                applicationId: new FormControl(applicationZoning.applicationId),
                applicationPropertyId: new FormControl(applicationZoning.applicationPropertyId),
                zone: new FormControl(zone, Validators.min(1)),
                jobId: new FormControl(this.jobId)
            });
            zonesControl.push(zoneGroup);
        });
    }
    sortZoneDropDownAlphabetically() {
        if (this.zones.length > 0) {
            this.zones.sort((a, b) => (a.value?.localeCompare(b?.value)));
        }
    }
    sortApplicationTypesAlphabetically() {
        if (this.applicationTypes.length > 0) {
            this.applicationTypes.sort((a, b) => (a.value?.localeCompare(b?.value)));
        }
    }
    onApplicationTypeSelected(index) {
        const duplicateSelectionFound = this.clearControlSelectionIfDuplicate(this.getApplicationTypes(), this.applicationTypeFormControlName, index, CreateApplicationDetailsTpamsConstants.DUPLICATE_APPLICATION_TYPE_WARNING_MESSAGE);
        if (duplicateSelectionFound) {
            this.updateApplicationTypeLimitUiState();
            this.syncRezoningStateWithSelection();
            return;
        }
        this.updateApplicationTypeLimitUiState();
        this.syncRezoningStateWithSelection();
    }
    onZoneSelected(index) {
        this.clearControlSelectionIfDuplicate(this.getZones(), this.zoneFormControlName, index, CreateApplicationDetailsTpamsConstants.DUPLICATE_ZONE_WARNING_MESSAGE);
    }
    onRezoningChecked(event) {
        const element = event.target.checked;
        this.rezoningChecked = element;
        const zonesControl = this.getZones();
        if (this.rezoningChecked) {
            if (zonesControl.length === 0) {
                this.addZoneControl();
            }
            zonesControl.enable();
            return;
        }
        zonesControl.clear();
        zonesControl.disable();
    }
    addApplicationTypeControl() {
        const applicationTypesControl = this.getApplicationTypes();
        const typeGroup = new FormGroup({
            type: new FormControl(null, [Validators.required])
        });
        applicationTypesControl.push(typeGroup);
    }
    resetApplicationTypesToDefaultControl() {
        const applicationTypesControl = this.getApplicationTypes();
        applicationTypesControl.clear();
        this.ensureApplicationTypeDropdownIsVisible();
    }
    ensureApplicationTypeDropdownIsVisible() {
        const applicationTypesControl = this.getApplicationTypes();
        if (applicationTypesControl.length > 0) {
            return;
        }
        // Keep one empty row so the first details load always shows the dropdown.
        this.addApplicationTypeControl();
    }
    addZoneControl() {
        const zonesControl = this.getZones();
        const zoneGroup = new FormGroup({
            zone: new FormControl(null, [Validators.required])
        });
        zonesControl.push(zoneGroup);
    }
    canAddSelectionControl(controls, controlName, availableOptions, warningMessage) {
        const selectedValues = this.getDistinctSelectedValues(controls, controlName);
        const allOptionsAlreadySelected = availableOptions.length > 0 && selectedValues.size >= availableOptions.length;
        if (allOptionsAlreadySelected) {
            this.appControllerService.showMessage(warningMessage, AlertType.Warning);
            return false;
        }
        return true;
    }
    getDistinctSelectedValues(controls, controlName) {
        const selectedValues = new Set();
        controls.controls.forEach(control => {
            const selectedOption = control.get(controlName)?.value;
            if (selectedOption?.value) {
                selectedValues.add(selectedOption.value.toLowerCase());
            }
        });
        return selectedValues;
    }
    clearControlSelectionIfDuplicate(controls, controlName, selectedIndex, warningMessage) {
        const selectedControl = controls.at(selectedIndex);
        const selectedOption = selectedControl.get(controlName)?.value;
        if (!selectedOption?.value) {
            return false;
        }
        const selectedValue = selectedOption.value.toLowerCase();
        const duplicateSelectionExists = controls.controls.some((control, index) => {
            if (index === selectedIndex) {
                return false;
            }
            const currentValue = control.get(controlName)?.value?.value;
            return currentValue?.toLowerCase() === selectedValue;
        });
        if (!duplicateSelectionExists) {
            return false;
        }
        selectedControl.get(controlName).setValue(null);
        this.appControllerService.showMessage(warningMessage, AlertType.Warning);
        return true;
    }
    syncRezoningStateWithSelection() {
        this.isRezoning = this.hasSelectedRezoningApplicationType();
        const zonesControl = this.getZones();
        if (!this.isRezoning) {
            this.rezoningChecked = false;
            zonesControl.clear();
            zonesControl.disable();
            return;
        }
        this.rezoningChecked = this.hasSelectedZoneValue() || zonesControl.enabled;
        if (this.rezoningChecked) {
            if (zonesControl.length === 0) {
                this.addZoneControl();
            }
            zonesControl.enable();
            return;
        }
        zonesControl.disable();
    }
    hasSelectedRezoningApplicationType() {
        const applicationTypesControl = this.getApplicationTypes();
        return applicationTypesControl.controls.some(control => {
            const selectedType = control.get(this.applicationTypeFormControlName)?.value;
            return this.isRezoningApplicationType(selectedType);
        });
    }
    isRezoningApplicationType(applicationType) {
        if (!applicationType?.value) {
            return false;
        }
        const typeValue = applicationType.value.toLowerCase();
        return typeValue.includes(this.rezoneKeywordRezone) || typeValue.includes(this.rezoneKeywordRezoning);
    }
    hasSelectedZoneValue() {
        const zonesControl = this.getZones();
        return zonesControl.controls.some(control => {
            const selectedZone = control.get(this.zoneFormControlName)?.value;
            return !!selectedZone?.value;
        });
    }
    loadApplicationTypeLimit() {
        const moduleId = this.getCurrentModuleIdForLimit();
        this.townPlanningService.getApplicationTypeLimitObservable(moduleId).subscribe((applicationTypeLimit) => {
            this.applicationTypeLimit = normalizeTpApplicationTypeLimit(applicationTypeLimit);
            this.updateApplicationTypeLimitUiState();
            this.changeDetectorRef.markForCheck();
        });
    }
    isApplicationTypeAddBlockedByLimit() {
        this.updateApplicationTypeLimitUiState();
        if (!this.applicationTypeLimitUiState.disableAdd) {
            return false;
        }
        this.appControllerService.showMessage(this.applicationTypeLimitReachedWarningMessage, AlertType.Warning);
        return true;
    }
    updateApplicationTypeLimitUiState() {
        if (!this.detailsForm) {
            return;
        }
        const currentVisibleControlCount = this.getApplicationTypeControlCountForLimit();
        this.applicationTypeLimitUiState = mapTpApplicationTypeLimitToUiState(this.applicationTypeLimit, currentVisibleControlCount);
        if (this.applicationTypeLimitUiState.fullWidthDropdown) {
            this.ensureApplicationTypeDropdownIsVisible();
        }
    }
    getCurrentModuleIdForLimit() {
        const createModuleId = Number(this.applicationCreateService.moduleID);
        if (Number.isFinite(createModuleId) && createModuleId > 0) {
            return createModuleId;
        }
        const selectedModuleId = Number(this.appControllerService.selectedModuleID);
        if (Number.isFinite(selectedModuleId) && selectedModuleId > 0) {
            return selectedModuleId;
        }
        return 0;
    }
    getApplicationTypeControlCountForLimit() {
        return this.getApplicationTypes().length;
    }
    getPersistedApplicationTypes(applicationTypes) {
        if (!Array.isArray(applicationTypes) || applicationTypes.length === 0) {
            return [];
        }
        return applicationTypes.filter((applicationType) => this.hasNonEmptyText(applicationType?.applicationType));
    }
    findApplicationTypeLookupOption(applicationTypeValue) {
        const matchingLookup = this.applicationTypes.find((lookupItem) => lookupItem.value === applicationTypeValue);
        return matchingLookup ?? null;
    }
    hasNonEmptyText(value) {
        if (typeof value !== "string") {
            return false;
        }
        return value.trim().length > 0;
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: TownplanningService },
        { type: SearchApplicationsService }
    ];
};
CreateApplicationDetailsTpamsComponent = CreateApplicationDetailsTpamsComponent_1 = __decorate([
    Component({
        selector: "app-create-application-details-tpams",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsTpamsComponent);
export { CreateApplicationDetailsTpamsComponent };
